<script setup lang="ts">
import useLanguage from '@/composables/useLanguage'
import { TButtonColor, TButtonVariant } from '@lifk/types'
import UITextButton from '../UITextButton.vue'

withDefaults(
  defineProps<{
    /** What text should be displayed on the button? */
    text?: string
    /** Is the button disabled? */
    disabled?: boolean
    /** What variant should be used for the button? */
    variant?: TButtonVariant
    color?: TButtonColor
  }>(),
  {
    variant: 'filled',
    color: 'primary'
  }
)

const i18n = useLanguage('UIModal')
</script>

<template>
  <UITextButton
    :variant="variant"
    :color="color"
    :text="text"
    size="small"
    type="submit"
    :disabled="disabled"
    data-testid="modal-submit-button"
  >
    <slot v-if="!text">{{ i18n.submit }}</slot>
    <template v-else>{{ text }}</template>
  </UITextButton>
</template>
